var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24.47 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_2);\n      }\n\n      .cls-3 {\n        fill: #091616;\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_3);\n        isolation: isolate;\n        opacity: .25;\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_2-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    x1: 301.73,
    y1: -409.46,
    x2: 301.73,
    y2: -402.61,
    gradientTransform: "translate(-285.16 -385.46) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bababa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2-2",
    "data-name": "Degradado sin nombre 2",
    x1: 297.4,
    y1: -402.84,
    x2: 297.4,
    y2: -385.46,
    xlinkHref: "#Degradado_sin_nombre_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    "data-name": "Degradado sin nombre 3",
    x1: 293.1,
    y1: -394.15,
    x2: 301.94,
    y2: -394.15,
    gradientTransform: "translate(-285.16 -385.46) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7c7c7c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.2,24v-6.85h10.73l-10.73,6.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.82,0H3.66C1.64,0,0,1.64,0,3.66v10.07c0,2.02,1.64,3.66,3.66,3.66h17.16c2.02,0,3.66-1.64,3.66-3.66V3.66c0-2.02-1.64-3.66-3.66-3.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.82,4.48H7.59c-2.32,0-4.19,1.88-4.19,4.19s1.88,4.19,4.19,4.19h9.23c2.32,0,4.19-1.88,4.19-4.19s-1.88-4.19-4.19-4.19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.78,6.28H7.94v4.83h8.84v-4.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.68,11.1c1.33,0,2.41-1.08,2.41-2.41s-1.08-2.41-2.41-2.41-2.41,1.08-2.41,2.41,1.08,2.41,2.41,2.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.78,11.1c1.33,0,2.41-1.08,2.41-2.41s-1.08-2.41-2.41-2.41-2.41,1.08-2.41,2.41,1.08,2.41,2.41,2.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatButton);
export default __webpack_public_path__ + "static/media/ChatButton.8144dfc5bba8d3d04a8152095fc6b3db.svg";
export { ForwardRef as ReactComponent };